import axios from 'axios'

export default defineNuxtPlugin({
  name: 'axiosPlugin',
  setup(nuxtApp) {
    const config = useRuntimeConfig()

    const api = axios.create({
      baseURL: import.meta.server ? config.public.apiUrl : window.origin,
      withCredentials: true,
    })

    api.interceptors.request.use((config) => {
      if (import.meta.server) {
        // ensure cookies are passed on ssr axios requests
        const event = nuxtApp.ssrContext?.event
        const cookie = event.node.req.headers.cookie
        config.headers['Cookie'] = cookie
      }
      return config
    })

    return {
      provide: {
        axios: api,
      },
    }
  },
})
